import { POST } from '@/api'
import { omit } from 'lodash'

export default {
  namespaced: true,
  state: {
    settings: {},
    busy: false,
  },
  mutations: {
    set(state, data) {
      state.settings = data
    },
    busy(state, busy) {
      state.busy = busy
    },
  },
  actions: {
    async get({ commit, state }) {
      if (state.busy) return false
      commit('busy', true)

      const { status, message, data } = await POST('/api/web/v2/mailconversion/list')

      if (status === 200) {
        commit('set', data)
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
    async update({ commit, state }, media) {
      if (state.busy) return false
      commit('busy', true)

      const req = omit(state.settings, ['forwardingAddress', 'resrakuSync', 'termAgreement'])
      req[media] = !state.settings[media]

      const { status, message } = await POST('/api/web/v2/mailconversion/update', req)

      if (status !== 200) {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
    async agree({ commit, state }) {
      if (state.busy) return false
      commit('busy', true)

      const { status, message } = await POST('/api/web/v2/mailconversion/term_agreement/update')

      if (status !== 200) {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
  },
}
